// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__DiLxM","title":"ClientReferral_title__QGrpA","itemText":"ClientReferral_itemText__aPAoz"};